const TrackerBlock = () => {
  const blocks = document.querySelectorAll('[data-block-type="selluxe-tracker"]');

  if (blocks.length === 0) return;

  blocks.forEach(block => {
    const addTrackerSwitch = block.querySelector('.switch > input[type="checkbox"]');
    const platforms = block.querySelectorAll('.platform-btn');
    const productIdInput = block.querySelector('input[name="platform"]');
    const priceContainer = block.querySelector('.price-meta');
    const oldPriceEl = priceContainer.querySelector('.old-price');
    const currentPriceEl = priceContainer.querySelector('.current-price');
    const discountEl = priceContainer.querySelector('.discount-badge');
    const discountValue = discountEl?.querySelector('.discount-value');

    const updateElements = () => {
      platforms.forEach(platform => {
        const isActivePlatform = platform.classList.contains('active');
        const isOnSale = platform.classList.contains('has-discount');

        if (isActivePlatform) {
          const platformId = parseInt(platform.dataset.productId);
          const discount = platform.dataset.discount;
          const price = platform.dataset.price;
          const oldPrice = platform.dataset.compareAtPrice;

          if (discountValue) discountValue.innerText = discount;
          if (productIdInput) productIdInput.dataset.value = platformId;
          if (oldPriceEl) oldPriceEl.innerText = oldPrice;
          if (currentPriceEl) currentPriceEl.innerText = price;

          priceContainer.classList.toggle('on-sale', isOnSale);
        }
      });
    };

    updateElements();

    platforms.forEach(platform => {
      platform.addEventListener('click', () => {
        platforms.forEach(btn => btn.classList.remove('active'));
        platform.classList.add('active');
        updateElements();
      });
    });

    const addTrackerProduct = async () => {
      const trackerProductId = productIdInput?.dataset.value;
      const shouldAddTracker = addTrackerSwitch?.checked;

      if (!shouldAddTracker || !trackerProductId) {
        console.log('Tracker not enabled or missing ID.');
        return;
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: trackerProductId,
            quantity: 1
          })
        });

        const data = await res.json();
        console.log('Tracker product added:', data);

        document.dispatchEvent(new CustomEvent('cart:refresh'));

        if (window?.CartDrawer?.instance?.renderContents) {
          window.CartDrawer.instance.renderContents();
        }

      } catch (error) {
        console.error('Error adding tracker product:', error);
      }
    };

    const mainForm = document.querySelector('form[action="/cart/add"]');
    if (mainForm) {
      const submitButton = mainForm.querySelector('button[type="submit"]');

      if (submitButton) {
        submitButton.addEventListener('click', () => {
          setTimeout(() => {
            addTrackerProduct();
          }, 1000)
        });
      }
    }
  });
};

window.addEventListener('DOMContentLoaded', TrackerBlock);
